import { adminService } from 'services';
import { browserHistory } from 'react-router';
import *  as userActions from './user';

export const FETCH_WEBSITES_BEGIN = 'admin/FETCH_WEBSITES_BEGIN';
export const FETCH_WEBSITES_SUCCESS = 'admin/FETCH_WEBSITES_SUCCESS';
export const FETCH_WEBSITES_ERROR = 'admin/FETCH_WEBSITES_ERROR';

export const FETCH_USERS_BEGIN = 'admin/FETCH_USERS_BEGIN';
export const FETCH_USERS_SUCCESS = 'admin/FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'admin/FETCH_USERS_ERROR';

export const FETCH_GLOBAL_BEGIN = 'admin/FETCH_GLOBAL_BEGIN';
export const FETCH_GLOBAL_SUCCESS = 'admin/FETCH_GLOBAL_SUCCESS';
export const FETCH_GLOBAL_ERROR = 'admin/FETCH_GLOBAL_ERROR';

export const SAVE_GLOBAL_BEGIN = 'admin/SAVE_GLOBAL_BEGIN';
export const SAVE_GLOBAL_SUCCESS = 'admin/SAVE_GLOBAL_SUCCESS';
export const SAVE_GLOBAL_ERROR = 'admin/SAVE_GLOBAL_ERROR';

export const SAVE_WEBSITE_BEGIN = 'admin/SAVE_BEGIN';
export const SAVE_WEBSITE_SUCCESS = 'admin/SAVE_SUCCESS';
export const SAVE_WEBSITE_ERROR = 'admin/SAVE_ERROR';

export const PUBLISH_WEBSITE = 'admin/PUBLISH_WEBSITE';
export const UNPUBLISH_WEBSITE = 'admin/UNPUBLISH_WEBSITE';

export const DELETE_WEBSITE_BEGIN = 'admin/DELETE_BEGIN';
export const DELETE_WEBSITE_ERROR = 'admin/DELETE_ERROR';

export function fetchWebsiteBegin(){
    return {
        type: FETCH_WEBSITES_BEGIN
    }
}

export function fetchWebsiteSuccess(data){
 return { type: FETCH_WEBSITES_SUCCESS, data: data };
}

export function fetchWebsiteError(error){
 return { type: FETCH_WEBSITES_ERROR, error: error };
}

export function fetchWebsites(){
    return (dispatch) => {
        dispatch(fetchWebsiteBegin());
        adminService().getWebsites().then((res)=>{
           return dispatch(fetchWebsiteSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchWebsiteError('Cannot fetch websites. Please try later.'));
        });
    }
}


export function fetchUsersBegin(){
    return {
        type: FETCH_USERS_BEGIN
    }
}

export function fetchUsersSuccess(data){
 return { type: FETCH_USERS_SUCCESS, data: data };
}

export function fetchUsersError(error){
 return { type: FETCH_USERS_ERROR, error: error };
}

export function fetchUsers(params){
    return (dispatch) => {
        dispatch(fetchUsersBegin());
        adminService().getUsers(params).then((res)=>{
           return dispatch(fetchUsersSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchUsersError('Cannot fetch users. Please try later.'));
        });
    }
}

export function deleteUser(shopName, params){
    return (dispatch)=>{
        adminService().deleteUser(shopName).then(()=>{
            dispatch(fetchUsers(params));
        }).catch(()=>{
            dispatch(fetchUsers(params));
        });
    }
}

export function updateSubscription(id, subscription, params){
    return (dispatch)=>{
        adminService().updateSubscription(id, subscription).then(()=>{
            dispatch(fetchUsers(params));
        }).catch(()=>{
            dispatch(fetchUsers(params));
        });
    }
}

export function fetchGlobalBegin(){
    return { type: FETCH_GLOBAL_BEGIN };
}

export function fetchGlobalSuccess(data){
    return { type: FETCH_GLOBAL_SUCCESS, data: data };
}

export function fetchGlobalError(error){
    return { type: FETCH_GLOBAL_ERROR, error: error };
}

export function fetchGlobalSettings(){
    return (dispatch) => {
        dispatch(fetchGlobalBegin());
        adminService().getGlobalSettings().then((res) => {
            return dispatch(fetchGlobalSuccess(res.data));
        }).catch(() => {
            return dispatch(fetchGlobalError('Cannot fetch global settings.'));
        });
    }
}

export function updateGlobalSettings(expiringEnabled){
    return (dispatch) => {
        adminService().updateGlobalSettings(expiringEnabled).then(() => {
            return dispatch(fetchGlobalSettings());
        }).catch(() => {
            return dispatch(fetchGlobalError('Cannot save global settings.'));
        });
    }
}

export function setUserTokenMode(id, tokenMode, params){
    return (dispatch) => {
        adminService().updateTokenMode(id, tokenMode).then(() => {
            dispatch(fetchUsers(params));
        }).catch(() => {
            dispatch(fetchUsers(params));
        });
    }
}

export function loadWebsite(id){
    return (dispatch) => {
        dispatch(fetchWebsiteBegin());
        adminService().getWebsites().then((res)=>{
           dispatch(fetchWebsiteSuccess(res.data));
           dispatch(openWebsite(id));
        }).catch((error)=> {
            return dispatch(fetchWebsiteError('Cannot fetch websites. Please try later.'));
        });
    }     
}


  
export function saveWebsiteBegin(){
    return {
        type: SAVE_WEBSITE_BEGIN
    }
}

export function saveWebsiteSuccess(website){
    return {
        type: SAVE_WEBSITE_SUCCESS,
        website: website
    }
}

export function saveWebsiteError(error){
    return {
        type: SAVE_WEBSITE_ERROR,
        msg: error
    }
}

export function saveWebsite(website){
    return (dispatch)=>{
        dispatch(saveWebsiteBegin());
        adminService().updateWebsite(website).then(()=>{
            return dispatch(saveWebsiteSuccess(website));
        }).catch((error)=>{
            return dispatch(saveWebsiteError(error));
        });
    }

}

export function deleteWebsiteBegin(){
    return {
        type: DELETE_WEBSITE_BEGIN
    }
}

export function deleteWebsiteError(error){
    return {
        type: DELETE_WEBSITE_ERROR,
        msg: error
    }
}

export function deleteWebsite(website){
    return (dispatch) =>{
        dispatch(deleteWebsiteBegin());
        adminService().deleteWebsite(website).then(()=>{
             dispatch(fetchWebsites());
        }).catch(()=>{
            dispatch(deleteWebsiteError('Cannot delete website'))
        });
    }
}


export function publish(website){
    return {
        type: PUBLISH_WEBSITE,
        website: website
    }
}

export function unpublish(website){
    return {
        type: UNPUBLISH_WEBSITE,
        website: website
    }
}

export function changeVisiblity(website, isPublic){
    return (dispatch) => {
        if (isPublic === true){
            dispatch(publish(website));
        }
        else{
            dispatch(unpublish(website));
        }
        dispatch(saveWebsite({
            ...website,
            isPublic: isPublic,
            needsApproval: false
        }));  
    }
}


const reducer = (state = {
    fetching: false,
    isSaving: false,
    list: [],
    users:[],
    usersTotal: 0,
    usersPage: 1,
    usersTotalPages: 1,
    expiringEnabled: false,
    globalLoading: false,
    globalError: null
}, action = {}) => {
  switch (action.type) {
    case SAVE_WEBSITE_SUCCESS:{
 
    let l = state.list.map((ws)=>{
            if (ws.id === action.website.id){
                return {
                    ...action.website
                }
            }
            return ws;
        });
        return {
            ...state,
            fetching: state.fetching,
            list: l
        }
    }
    case FETCH_WEBSITES_BEGIN:
      return {
          ...state,
          fetching: true,
          isSaving: false,
      };
    case FETCH_WEBSITES_SUCCESS:

        return {
            ...state,
            fetching: false,
            list: action.data
        };
    case FETCH_WEBSITES_ERROR:
        return {
            ...state,
            fetching: false,
            isSaving: false,
            list: []
        };
     case FETCH_USERS_BEGIN:
      return {
          ...state,
          fetching: true,
          isSaving: false
      };
    case FETCH_USERS_SUCCESS:

        return {
            ...state,
            fetching: false,
            users: Array.isArray(action.data.users) ? action.data.users : (Array.isArray(action.data) ? action.data : []),
            usersTotal: action.data.total || 0,
            usersPage: action.data.page || 1,
            usersTotalPages: action.data.totalPages || 1
        };
    case FETCH_USERS_ERROR:
        return {
            ...state,
            fetching: false,
            isSaving: false,
            users: []
        };

    case FETCH_GLOBAL_BEGIN:
        return {
            ...state,
            globalLoading: true,
            globalError: null
        };
    case FETCH_GLOBAL_SUCCESS:
        return {
            ...state,
            globalLoading: false,
            globalError: null,
            expiringEnabled: !!(action.data && action.data.expiringEnabled)
        };
    case FETCH_GLOBAL_ERROR:
    case SAVE_GLOBAL_ERROR:
        return {
            ...state,
            globalLoading: false,
            globalError: action.error || 'Global settings error'
        };
    case SAVE_GLOBAL_BEGIN:
        return {
            ...state,
            globalLoading: true
        };
    case SAVE_GLOBAL_SUCCESS:
        return {
            ...state,
            globalLoading: false,
            globalError: null
        };
  
    case PUBLISH_WEBSITE:{
        let l = state.list.map((ws)=>{
            if (ws._id === action.website._id){
                return {
                    ...ws,
                    isPublic: true,
                    needsApproval: false
                }
            }
            else{
                return {...ws};
            }
        });
        return {
            ...state,
            fetching: state.fetching,
            list: l
        }
    }
    case UNPUBLISH_WEBSITE:{
        let l = state.list.map((ws)=>{
            if (ws._id === action.website._id){
                return {
                    ...ws,
                    isPublic: false,
                    needsApproval: false
                }
            }
            else{
                return {...ws};
            }
        });
        return {
            ...state,
            fetching: state.fetching,
            list: l
        }
    }
   

    case SAVE_WEBSITE_BEGIN:
    return {
        ...state,
        isSaving: true
    }

    case SAVE_WEBSITE_ERROR:
    return {
        ...state,
        isSaving: false,
        msg: action.msg
    }

    case SAVE_WEBSITE_SUCCESS:
    return {
        ...state,
        isSaving: false
    }
    case userActions.LOGOUT_ERROR_USER:
    case userActions.LOGIN_ERROR_USER:
    case userActions.SIGNUP_ERROR_USER:
    case userActions.LOGOUT_SUCCESS_USER:
        return {
            list:[],
            users:[]
        }       
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// app/modules/admin.js